import { render } from "./BtnHeaderPrime.vue?vue&type=template&id=3d341b88"
import script from "./BtnHeaderPrime.vue?vue&type=script&lang=js"
export * from "./BtnHeaderPrime.vue?vue&type=script&lang=js"

import "./BtnHeaderPrime.vue?vue&type=style&index=0&id=3d341b88&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__